const priorityTimezones = [
  { label: 'Europe/Paris', value: 'Europe/Paris' },
  { label: 'Europe/London', value: 'Europe/London' },
  { label: 'Asia/Dubai', value: 'Asia/Dubai' },
  { label: 'America/New_York', value: 'America/New_York' },
  { label: 'America/Los_Angeles', value: 'America/Los_Angeles' },
  { label: 'Europe/Zurich', value: 'Europe/Zurich' },
]

const allTimezones: string[] =
  (Intl as any).supportedValuesOf?.('timeZone') || []

export const timezones = [
  ...priorityTimezones,
  ...allTimezones
    .filter((tz) => !priorityTimezones.some((p) => p.value === tz))
    .sort()
    .map((tz) => ({ label: tz, value: tz })),
]
